<template>
  <div class="shopReview">
    <div class="shopReview__header">
      <div class="shopReview__isCompany">{{ shopReview.is_company ? '法人利用' : '個人利用' }}</div>
      <views-rating-stars :rating="shopReview.average_rating"></views-rating-stars>
    </div>
    <div class="shopReview__usage">利用用途 | {{ shopReview.category_label }}</div>
    <div class="shopReview__title">{{ shopReview.title }}</div>
    <div class="shopReview__contents">
      <span v-if="isExpanded">{{ shopReview.contents }}</span>
      <span v-else>{{ truncatedContents }}</span>
      <a href="#" v-if="shouldShowMoreLink && !isExpanded" @click.prevent="expand">もっと見る<i class="fas fa-chevron-down"></i></a>
    </div>
    <div class="shopReview__price">
      <div class="shopReview__price__container">
        <span class="shopReview__price-yen"><span>&#165;</span></span>
        <span class="shopReview__price-label">費用明細</span>
        <span class="shopReview__price-people">{{ shopReview.people }}名/
          <span class="shopReview__price-amount">{{ shopReview.total_price | formatCurrency }}</span>
          <span class="shopReview__price-currency">円</span>
        </span>
      </div>
    </div>
    <div class="shopReview__meta">
      <span>訪問日 {{ visitDate }}</span>
      <span>投稿日 {{ createdAt }}</span>
      <span>記入者 男性 : {{ shopReview.age }}代</span>
    </div>
  </div>
</template>

<script>
import ViewsRatingStars from './viewsRatingStars.vue';
export default {
    components: {
        'views-rating-stars': ViewsRatingStars,
    },
    props: {
        shopReview: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            maxLength: 100,
            isExpanded: false,
        };
    },
    computed: {
        shouldShowMoreLink() {
            return this.shopReview.contents?.length > this.maxLength;
        },
        truncatedContents() {
            if (this.shopReview.contents?.length > this.maxLength) {
                return this.shopReview.contents.slice(0, this.maxLength) + '...';
            }
            return this.shopReview.contents;
        },
        visitDate() {
            return moment(this.shopReview.event_date).format('YYYY/MM');
        },
        createdAt() {
            return moment(this.shopReview.created_at).format('YYYY/MM/DD');
        },
    },
    methods: {
        expand() {
            this.isExpanded = true;
        }
    },
};
</script>
